import { useIntl } from '@capsicum/common';
import { Alert, Text } from '@capsicum/common-web';
import { AlertIcon } from '@capsicum/common-web/icons';
import Link from 'next/link';
import { type ReactNode } from 'react';
import styled from 'styled-components';

import { NCWSendChzAlert } from '../../../ui';

export type SendChilizAlertProps = {
	alertType: 'message' | 'warning';
};

export const SendChilizAlert = ({ alertType }: SendChilizAlertProps) => {
	const { $t } = useIntl();

	if (alertType === 'message') {
		return <NCWSendChzAlert />;
	}

	// The error message including the link for the Alert of Warning type
	const chilizError = $t('ncWallet.send.enterAmount.chilizErrorSubtitle', {
		link: (chunks: Array<ReactNode>) => (
			<Link data-testid="ncw-send-chilizAmount-error-link" href="/nc-wallet/receive">
				<S.LinkText boxless variant="text4">
					{chunks}
				</S.LinkText>
			</Link>
		)
	});

	return <Alert closable={false} icon={AlertIcon} subTitle={chilizError} type="warning" />;
};

namespace S {
	export const LinkText = styled(Text)`
		color: ${({ theme }) => theme.colors.text.brand.enabled};
	`;
}
